import type { BoxProps } from '@chakra-ui/react';
import { Box, Input } from '@chakra-ui/react';
import { Minus, Plus } from '@time-line/components/icons';

import { Button } from './Button';

export interface StepperProps extends BoxProps {
  quantity: number;
  handleChange: (newValue: number) => void;
  maxQuantity?: number;
  minQuantity?: number;
  isUpdating?: boolean;
}

export function Stepper({
  quantity,
  maxQuantity,
  minQuantity = 1,
  handleChange,
  isUpdating,
  ...rest
}: StepperProps) {
  const isPlusDisabled = maxQuantity ? quantity >= maxQuantity : false;
  const isMinusDisabled = quantity <= minQuantity;

  return (
    <Box display="grid" width={130} pos="relative" {...rest}>
      <Button
        aria-label="Decrease quantity by one"
        disabled={isMinusDisabled || isUpdating}
        iconComponent={Minus}
        left={0}
        onClick={() => handleChange(quantity - 1)}
      />
      <Input
        aria-label="Quantity"
        borderColor="gray.600"
        padding={0}
        size="xs"
        fontFamily="mono"
        isReadOnly
        textAlign="center"
        value={quantity}
      />
      <Button
        aria-label="Increase quantity by one"
        disabled={isPlusDisabled || isUpdating}
        iconComponent={Plus}
        onClick={() => handleChange(quantity + 1)}
        right={0}
      />
    </Box>
  );
}
